import styled from 'styled-components';
import { TransactionType } from '../../types/enums';

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #f3f4f6;

  max-height: 600px;
  overflow: hidden;
`;
export const SidebarHeader = styled.div`
  padding: 10px;
  border-bottom: 1px solid #e5e7eb;

  h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.text || '#1f2937'};
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const SidebarContent = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: calc(100vh - 120px);
  padding: 0 16px;

  @media (max-width: 768px) {
    max-height: none;
    height: auto;
  }
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  padding: 16px;
  border: none;
  border-top: 1px solid #e5e7eb;
  background: white;
  color: ${({ theme }) => theme.colors?.text || '#374151'};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #f9fafb;
    color: ${({ theme }) => theme.colors?.primary || '#3b82f6'};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors?.text_grey || '#6b7280'};

  .empty-icon {
    font-size: 3rem;
    margin-bottom: 16px;
    opacity: 0.5;
  }

  p {
    margin: 0;
    font-size: 0.875rem;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;

  @media (max-width: 600px) {
    padding: 12px;
    flex-direction: column;
  }

  &:hover {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-left-color: ${({ theme }) =>
      theme.colors?.primary || '#3b82f6'};
    transform: translateX(2px);
  }
`;

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  margin-top: 4px;
`;

export const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 18px;
    height: 18px;
  }
`;

export const Connector = styled.div`
  width: 2px;
  height: 48px;
  background: linear-gradient(to bottom, #e5e7eb, #f3f4f6);
  margin-top: 8px;
  border-radius: 1px;
`;

export const ContentContainer = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const TransactionBadge = styled.div<{ type: TransactionType }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.025em;

  ${({ type }) =>
    type === TransactionType.CREDIT
      ? `
    background: linear-gradient(135deg, #dcfce7, #bbf7d0);
    color: #166534;
    border: 1px solid #86efac;
    
    &::before {
      content: "↗";
      font-size: 0.75rem;
      font-weight: bold;
    }
  `
      : `
    background: linear-gradient(135deg, #fee2e2, #fecaca);
    color: #991b1b;
    border: 1px solid #fca5a5;
    
    &::before {
      content: "↘";
      font-size: 0.75rem;
      font-weight: bold;
    }
  `}
`;

export const Amount = styled.p`
  font-weight: 700;
  font-size: 1rem;
  margin: 0 0 8px 0;
  color: ${({ theme }) => theme.colors?.text || '#1f2937'};
`;

export const Description = styled.p`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors?.text_grey || '#6b7280'};
  margin: 0 0 6px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CreatedBy = styled.p`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors?.text_grey || '#9ca3af'};
  margin: 0 0 8px 0;
  font-style: italic;
`;

export const DateTime = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 0.7rem;
  color: ${({ theme }) => theme.colors?.text_grey || '#9ca3af'};
  font-weight: 500;
  line-height: 1.2;
`;
